<template>
  <div class="content-inner">
    <div class="col-12">
      <div v-if="caregroup" class="row">
        <div class="col-3" style="line-height: 3em">
          <h6 style="line-height: 42px">{{ $t("message.Select") }}:</h6>
        </div>
        <div class="col-9">
          <el-select class="select-default questionnaire-select" :placeholder="$t('message.Single Select')" v-model="selectedQuestionnaire" v-if="caregroup">
            <el-option v-for="questionnaire in caregroup.questionnaires" class="select-default" :value="questionnaire.formSchema" :label="questionnaire.name" :key="questionnaire.name"></el-option>
          </el-select>
        </div>
      </div>
      <div v-if="!caregroup" class="col-12 text-center">
        <i class="fa fa-info-circle"></i>
        {{ $t("message.No Questionnaires available") }}
      </div>
      <form-renderer :schema="selectedQuestionnaire" v-if="selectedQuestionnaire && showForm" model style="margin-top: 2em" :read-only="false" ref="formRenderer"></form-renderer>
    </div>

    <n-button v-if="caregroup" type="primary" social icon round size="lg" style="top: auto; inset-inline-end: 10px; bottom: 0px; left: auto; position: fixed" @click.native="saveAnswers()">
      <i class="now-ui-icons ui-1_check"></i>
    </n-button>
  </div>
</template>

<script>
import FormRenderer from "src/pages/carenation/components/FormRenderer.vue";
import moment from "moment";

export default {
  name: "answer-questionnaire",

  components: {
    FormRenderer,
  },

  data() {
    return {
      selectedQuestionnaire: null,
      patient: null,
      caregroup: null,
      showForm: true,
    };
  },

  computed: {
    user() {
      if (localStorage.user) {
        return JSON.parse(localStorage.user);
      }
    },
  },

  watch: {
    selectedQuestionnaire: function () {
      this.showForm = false;
      setTimeout(() => {
        this.showForm = true;
      }, 100);
    },
  },

  async mounted() {
    this.patient = await this.$store.dispatch(
      "getPatientByPatientId",
      this.$route.params.patientId
    );

    if (!this.patient) {
      console.debug("Patient context missing");
      return;
    }

    if (!this.patient.caregroup) {
      console.debug("Patient not Present or no caregroup assigned");
      return;
    }

    this.caregroup = await this.$store.dispatch(
      "getCaregroup",
      this.patient.caregroup
    );

    if (
      this.caregroup.questionnaires &&
      this.caregroup.questionnaires.length > 0
    ) {
      this.selectedQuestionnaire = this.caregroup.questionnaires[0].formSchema;
    }
  },

  methods: {
    getFormattedDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    async saveAnswers() {
      let selectedQuestionnaireObject = this.caregroup.questionnaires.find(
        (questionnaire) => {
          return questionnaire.formSchema == this.selectedQuestionnaire;
        }
      );

      let answer = this.$refs.formRenderer.getData();

      await this.$store.dispatch("saveQuestionnaireAnswers", {
        patientId: this.patient.patientId,
        name: selectedQuestionnaireObject.name,
        answer: JSON.stringify(answer),
      });

      swal
        .fire({
          title: this.$t("message.Questionnaire answered"),
          text: this.$t("message.Done"),
          type: "success",
          timer: 3000,
          showCloseButton: true,
        })
        .then(() => {
          this.$router.push({
            path: "/questionnaires/" + this.$route.params.patientId,
          });
        });
    },
  },
};
</script>

<style scoped>
/deep/ .el-select.questionnaire-select .el-input .el-input__inner {
  margin-top: 0px;
}
/deep/ .el-select.questionnaire-select {
  width: 100%;
}
/deep/ .el-select.questionnaire-select .el-input__suffix {
  top: -4px;
}
</style>
